"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var text_1 = require("./text");
function TelDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/tel.html',
        controller: /** @class */ (function (_super) {
            __extends(TelController, _super);
            function TelController($scope, book) {
                'ngInject';
                return _super.call(this, $scope, book) || this;
            }
            return TelController;
        }(text_1.TextController)),
        controllerAs: 'telCtrl'
    };
}
exports.TelDirective = TelDirective;
